import React, { useEffect } from "react";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import { fetchCurrentUser, updateData, resetFilters } from "./redux/activitiesSaga";
import { useDispatch, useSelector } from "react-redux";
import CustomDateRanges from "./smartComponents/customDateRanges";
import DatePicker from "./smartComponents/datePicker";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { Dropdown } from "./smartComponents/dropdown";
import { LineChart } from "./smartComponents/LineChart";
import { ContactLogsTable } from "./smartComponents/ContactLogsTable";
import ErrorBoundary from "../../../components/errorBoundary/errorBoundary";
import LearnMore from "../../../components/learnMore/learnMore";

export const Activities = ({ notifications }) => {
  const {
    areChartsLoading,
    filtersDirty,
    isLoading,
    isAllSitesMode,
    selectedFilters: { startDate, endDate },
    chartsData: {
      tableData: { isLoading: isTableLoading },
      lineChartData: { isLoading: isLineChartLoading }
    }
  } = useSelector((state) => state.activities);

  const dispatch = useDispatch();
  let renderUpdateBtn = () => {
    let checkForInvalidDate = startDate !== "Invalid date" && endDate !== "Invalid date";
    if (filtersDirty && !isLoading && checkForInvalidDate) {
      return (
        <button className="submit" onClick={() => dispatch(updateData())}>
          Update
        </button>
      );
    }
  };

  let renderResetBtn = () => {
    if (filtersDirty && !isLoading) {
      return (
        <button className="submit reset" onClick={() => dispatch(resetFilters())}>
          Reset
        </button>
      );
    }
  };

  useEffect(() => {
    dispatch(fetchCurrentUser());
  }, []);

  const content = () => {
    return (
      <>
        {isAllSitesMode ? (
          <p className="error error--big">Not Available in All Sites View</p>
        ) : (
          <div id="module-date-filters" data-testid="activities">
            <div id="override-edit-selection-bar" className="edit-selections-bar">
              <div className="top-filter">
                <div style={{ flexBasis: "25%" }}>
                  <div className="select-box-no-width" data-testid="Staffs">
                    <p data-testid="filterTitle">Staff</p>
                    <Dropdown placeholder="Staffs" sliceKey="staffs" />
                  </div>
                </div>

                <div className="top-filter__right">
                  <div
                    className="select-box-no-width date-range-select-box"
                    data-testid="Date Range"
                  >
                    <p data-testid="filterTitle">Date Range</p>
                    <CustomDateRanges />
                  </div>

                  <div className="date-select-box multi" data-testid="Date">
                    <p data-testid="filterTitle">Date</p>
                    <DatePicker />
                  </div>
                </div>
              </div>

              {renderUpdateBtn()}
              {renderResetBtn()}
            </div>

            <div>
              {areChartsLoading ? (
                <LoadingAnimation text="Loading.." />
              ) : (
                <>
                  {isLineChartLoading ? (
                    <LoadingAnimation text="Updating data..." />
                  ) : (
                    <LineChart />
                  )}
                  {isTableLoading ? (
                    <LoadingAnimation text="Updating data..." />
                  ) : (
                    <ContactLogsTable />
                  )}
                </>
              )}
            </div>
          </div>
        )}
      </>
    );
  };
  return (
    <ErrorBoundary moduleName="Staff Activities" {...notifications}>
      <SectionToggle
        isLoading={isLoading}
        title="Activities"
        content={content()}
        learnMore={<LearnMore title="Activities" content={learnMoreContent} />}
      />
    </ErrorBoundary>
  );
};

const learnMoreContent = (
  <>
    Track employee engagement with your customers by their logged texts, emails, calls, and recorded
    in-person conversations within ClubReady.
    <br />
    <br />
    <b>Calls:</b> All logs that are entered as “Called” in ClubReady.
    <br />
    <br />
    <b>Texts:</b> All logs that are entered as “Texted” in ClubReady except system generated
    text/SMS.
    <br />
    <br />
    <b>Emails:</b> All logs that are entered as “Email” in ClubReady except system generated emails.
    <br />
    <br />
    <b>In-Person:</b> All logs that are entered as “Spoke Face to Face” in ClubReady.
    <br />
    <br />
    <b>Total Contacts:</b> Totaling up all four lines of Calls, Texts, Emails & In-Person.
    <br />
    <br />
    <b>Staff:</b> This reflects the staff member who added the log type.
    <br />
    <br />
    <b>Prospect Type:</b> Refers to the customer’s profile status in ClubReady. Also known as ‘
    Prospect Type’ or Lead Type” in ClubReady.
    <br />
    <br />
    <i>
      Note - ClubReady cannot store the historical status of each log. All contacts logs will be
      shown under the current prospect type.
    </i>
    <br />
    <br />
    Modify your view with the staff, prospect, and calendar options to create the view you need to
    evaluate client management.
  </>
);
